<template>
    <div  :style="oracle.isMobile() ? 'width: 100%;' : 'width: 80%'">
        <div class="d-flex flex-row align-content-center mb-3" v-for="(item, index) in reviews" :key="index">
            <img :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
                 :src="item.user != null && item.user.user_avatar != null ? item.user.user_avatar :
                                 require('@/assets/image/user_avatar.png')"
                 alt="">
            <div class="d-flex flex-column flex">
                <v-card style="padding: 10px 20px">
                    <div style="width: 100%" class="d-flex flex-row">
                        <h6 class="font-weight-bold">{{item.user.username}}</h6>
                        <h6 class="font-weight-bold">
                            <span :class="isEN ? 'ml-3' : 'mr-3'"
                                  style="font-weight: normal !important; font-size: 12px">{{oracle.date(item.create_at)}}</span>
                        </h6>
                        <v-rating v-if="!oracle.isMobile()" :class="isEN ?  'ml-auto' : 'mr-auto'" readonly size="small" color="primary"
                                  v-model="item.rate"></v-rating>
                    </div>
                    <v-rating v-if="oracle.isMobile()" :class="isEN ?  'ml-auto' : 'mr-auto'" readonly size="small" color="primary"
                              v-model="item.rate"></v-rating>
                    <p style="text-align: unset !important;">{{item.text}}</p>
                </v-card>
            </div>
        </div>
        <h5 v-if="user != null" class="font-weight-bold mt-5">{{language.lang('Write a review')}}</h5>
        <div v-if="user != null" class="d-flex flex-row align-content-center mt-2" style="align-items: flex-start">
            <img :class="'shadow-lg--hover review-avatar ' + (isEN ? 'mr-2' : 'ml-2')"
                 :src="user != null && user.user_avatar != null ? user.user_avatar :
                                 require('@/assets/image/user_avatar.png')"
                 alt="">
            <div class="d-flex flex-column flex">
                <v-card style="padding: 10px 20px">
                    <v-textarea flat :placeholder="language.lang('Write a review for this consultant')" v-model="text"
                    ></v-textarea>
                    <div style="align-items: end" class="d-flex flex-row align-content-space-between">
                        <v-rating color="primary" v-model="rate"></v-rating>
                        <base-button tag="span" @click="submitReview"
                                     type="default"
                                     :class="'mt-4 ' + (isEN ? 'ml-auto float-right' : 'mr-auto float-left')">
                            {{language.lang('Submit Review')}}
                        </base-button>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        props: {
            lawyer: Object
        },
        data: () => ({
            oracle: oracle,
            rate: 5,
            user: null,
            text: null,
            language: language,
            isEN: oracle.isEN(),
            reviews: [],
            isLawyer: oracle.isLawyer()
        }), methods: {
            submitReview() {
                oracle.axios('lawyer/addComment', {
                    text: this.text
                    , rate: this.rate, lawyer_id: this.lawyer.lawyer_id
                }, (res) => {
                    oracle.showMessage(language.lang('Thank you for your comment, it will be displayed in a few hours.')
                        , null, null, 'checked')
                })
            }
        },
        mounted() {
            oracle.axios('lawyer/getComments', {parent_by: this.lawyer.lawyer_id, limit_by: 1000}, (res) => {
                this.reviews = res.data
            })
            if (oracle.isLoggedIn() && !this.isLawyer) {
                oracle.axios('user/getProfile', {}, (res) => {
                    this.user = res.data
                })
            }
        }
    };
</script>
<style>
</style>
